export const isArray = (value) => Array.isArray(value);

export const hasArrayValues = (value) => Array.isArray(value) && !!value.length;
